export default "__VITE_ASSET__C$hFMg6d__"